import React from "react";

const Library = () => {
  return (
    <div id="component-2" className="tab-content pane-switch-component-parts"></div>
  );
}

export default Library;
